import React, { FC, ReactNode } from 'react'

import { FormattedMessage } from 'react-intl'

import {
  allCitiesPath,
  allRegionsPath,
  seoGeoLandingPath,
} from 'components/page/Landing/constants'
import { LandingRouterLink } from 'components/page/Landing/LandingView/LandingView.styled'
import { mergeAllUrls } from 'functions/mergeAllUrls'

export const ShowMore: FC<{
  locale: string
  country: string | undefined
  countryId: string | undefined
  region: string | undefined
  regionId: number | undefined
  locationType: string | undefined
  locationName: ReactNode | string
}> = ({
  locale,
  country,
  countryId,
  region,
  regionId,
  locationType,
  locationName,
}) => {
  const text = (
    <FormattedMessage
      id={`landing.nearest_locations.${locationType}`}
      values={{ locationName }}
    />
  )

  if (region && regionId) {
    return (
      <LandingRouterLink
        to={mergeAllUrls(
          locale,
          seoGeoLandingPath,
          country!,
          `${region}-${regionId}`,
          allCitiesPath
        )}
        data-name="all-cities-action"
      >
        {text}
      </LandingRouterLink>
    )
  }

  return (
    <LandingRouterLink
      to={mergeAllUrls(
        locale,
        seoGeoLandingPath,
        `${country}-${countryId}`,
        allRegionsPath
      )}
      data-name="all-regions-action"
    >
      {text}
    </LandingRouterLink>
  )
}
